import React, { createContext, useContext, useMemo } from 'react';

export interface IEmergencyBannerContext {
  shouldShowEmergencyBanner: boolean;
  text?: string | null;
  setShouldShowEmergencyBanner: (shouldShowEmergencyBanner: boolean) => void;
  setText: (text?: string | null) => void;
}

export const EmergencyBannerContext = createContext<IEmergencyBannerContext>({
  shouldShowEmergencyBanner: false,
  setShouldShowEmergencyBanner: () => {},
  setText: () => {},
});

export const useEmergencyBannerContext = () => useContext(EmergencyBannerContext);

export const EmergencyBannerProvider = ({ children }: { children: React.ReactNode }) => {
  const [shouldShowEmergencyBanner, setShouldShowEmergencyBanner] = React.useState(false);
  const [text, setText] = React.useState<string | null>();

  const value = useMemo(() => {
    return { shouldShowEmergencyBanner, setShouldShowEmergencyBanner, text, setText };
  }, [shouldShowEmergencyBanner, text]);

  return (
    <EmergencyBannerContext.Provider value={value}>{children}</EmergencyBannerContext.Provider>
  );
};
